module.exports = __webpack_public_path__ + "static/media/edgeware-2.9981426e.png";